import axios from 'axios';
import { environment } from '../../environments/environment';
import { ExplainabilityDataElement } from '../Components/Explainability/explainabilityTypes';

/**
 * A campaign's explainability stage rows (`/agent/flow/context`).
 *
 * Without a group, the whole flow: population stages in full, customer stages
 * rolled up. With one, the reasoning behind that Insights group — its
 * `groupIdentifier` — from each case's current run. The control plane scopes a
 * group lookup to the caller's org, so none is sent from here.
 */

const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
    };
};

export interface StageContextScope {
    campaignId: string;
    /** An Insights row's groupIdentifier; omitted for the whole flow. */
    groupIdentifier?: string | null;
    /**
     * The activity that produced the group, when the same identifier (a customer id)
     * is produced by several. Narrows the lookup to the row's own capsule.
     */
    activityTemplateCode?: string | null;
}

export const explainabilityService = {
    async getStageContext(
        { campaignId, groupIdentifier, activityTemplateCode }: StageContextScope,
        { signal }: { signal?: AbortSignal } = {}
    ): Promise<ExplainabilityDataElement[]> {
        const data = groupIdentifier
            ? {
                campaignId,
                mode: 'group',
                groupIdentifier,
                ...(activityTemplateCode ? { activityTemplateCode } : {}),
            }
            : { campaignId };
        const response = await axios.post(
            `${environment.controlplaneUrl}/agent/flow/context`,
            { data },
            { headers: getHeaders(), signal }
        );
        return Array.isArray(response.data?.data) ? response.data.data : [];
    },
};
